import CalcsPage from './list';

export default CalcsPage;
